import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FleetIntro = _resolveComponent("FleetIntro")!
  const _component_ResourceTable = _resolveComponent("ResourceTable")!

  return (_openBlock(), _createElementBlock("div", null, [
    ($options.shouldShowIntro && !$props.loading)
      ? (_openBlock(), _createBlock(_component_FleetIntro, {
          key: 0,
          schema: $props.schema,
          "is-creatable": $data.permissions.gitRepos || $data.permissions.helmOps,
          labelKey: 'application',
          route: $options.createLocation,
          icon: 'icon-repository'
        }, null, 8, ["schema", "is-creatable", "route"]))
      : _createCommentVNode("", true),
    _cache[0] || (_cache[0] = _createTextVNode()),
    (!$options.shouldShowIntro)
      ? (_openBlock(), _createBlock(_component_ResourceTable, _mergeProps({ key: 1 }, _ctx.$attrs, {
          "key-field": "_key",
          schema: $props.schema,
          headers: $options.headers,
          rows: $options.filteredRows,
          loading: $props.loading,
          "use-query-params-for-simple-filtering": $props.useQueryParamsForSimpleFiltering,
          namespaced: !$props.workspace
        }), null, 16, ["schema", "headers", "rows", "loading", "use-query-params-for-simple-filtering", "namespaced"]))
      : _createCommentVNode("", true)
  ]))
}